import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-org-reports-actions-renderer',
  standalone: true,
  imports: [MatIconModule],
  template: `
    <div class="actions-container">
      <button class="actionButton viewButton" mat-mini-fab data-action="view" title="View Report">
        <mat-icon data-action="view">visibility</mat-icon>
      </button>
      <button class="actionButton downloadButton" mat-mini-fab data-action="download" title="Download Report">
        <mat-icon data-action="download">download</mat-icon>
      </button>
      @if (isAdmin) {
        <button class="actionButton deleteButton" mat-mini-fab data-action="delete" title="Delete Report">
          <mat-icon data-action="delete">delete</mat-icon>
        </button>
      }
    </div>
  `,
  styles: [`
    .actions-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      gap: 4px;
    }
    .actionButton {
      cursor: pointer;
    }
    .viewButton {
      background-color: #0099ab;
      color: white;
    }
    .downloadButton {
      background-color: #0099ab;
      color: white;
    }
    .deleteButton {
      background-color: #dc2626;
      color: white;
    }
  `],
})
export class OrgReportsActionsRendererComponent implements ICellRendererAngularComp {
  isAdmin = false;

  agInit(params: ICellRendererParams): void {
    this.isAdmin = params.context?.isAdmin ?? false;
  }

  refresh(params: ICellRendererParams): boolean {
    this.isAdmin = params.context?.isAdmin ?? false;
    return true;
  }
}
